<section class="breadcrumbs_common bg_img pos_relative">
    <div class="overlay-innerpage"></div>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumbs_content">
                    <h2 class="text-white">Eligibility & Intake</h2>
                    <ul class="breadcrumb">
                        <li>
                            <a routerLink="/">Home</a>
                        </li>
                        /
                        <li class="active">
                            <a href="javascript:void(0);">Eligibility & Intake</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <!-- <div class="sec-title">
            <h2><span>Intake</span></h2>
        </div> -->
        <table class="table table-bordered example display nowrap ">
            <thead>
                <tr>
                    <th>Sr. No.</th>
                    <th>Name of College / Institute</th>
                    <th>Location</th>
                    <th>Name of Courses</th>
                    <th>Branch</th>
                    <th>Intake</th>
                    <th>Eligibility</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td>G. H. Raisoni College of Arts, Commerce & Science</td>
                    <td>Pune</td>
                    <td>B. B. A. (Three Years)</td>
                    <td>-</td>
                    <td>80</td>
                    <td>The minimum eligibility for admission is 40% marks in class 12 Board Examination with any
                        stream.</td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>G. H. Raisoni College of Arts, Commerce & Science</td>
                    <td>Pune</td>
                    <td>B.C.A. (Three Years)</td>
                    <td>-</td>
                    <td>80</td>
                    <td>The minimum eligibility for admission is 40% marks in class 12 Board Examination with any
                        stream.</td>
                </tr>
                <tr>
                    <td>3</td>
                    <td>G. H. Raisoni College of Arts, Commerce & Science</td>
                    <td>Pune</td>
                    <td>B.Sc. (Computer Science)</td>
                    <td>Computer Science</td>
                    <td>80</td>
                    <td>The minimum eligibility for admission is 40% marks in class 12 Board Examination and the student
                        must have studied Science stream with Mathematics as a subject.</td>
                </tr>
                <tr>
                    <td>4</td>
                    <td>G. H. Raisoni College of Arts, Commerce & Science</td>
                    <td>Pune</td>
                    <td>B. Com.</td>
                    <td>Commerce</td>
                    <td>120</td>
                    <td>The minimum eligibility for admission is 40% marks in class 12 Board Examination with any
                        stream.</td>
                </tr>
            </tbody>
        </table>
    </div>
</section>